import script from "./PasswordChangeForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordChangeForm.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordChangeForm.vue?vue&type=style&index=0&id=3a7efeb3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a7efeb3"]])

export default __exports__